/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React from "react";
import sass from "pages/StepPages/StepFour/One/step.module.sass";
import IndexPage from "pages/StepPages/StepFour/IndexPage";
import { Route, Routes, useLocation } from "react-router-dom";
import Tables from "pages/StepPages/StepFour/One/Tables";

/**
 * Содержит вложенный роутинг, первый ведет на страницу со списком объектов угроз,
 * второй на компонент с таблицами для заполнения этого объекта угроз
 */
const One = () => {
	const location = useLocation();
	return (
		<div className={sass.wrapper}>
			<Routes location={location.pathname}>
				<Route index element={<IndexPage />} />
				<Route path={"/thread/:threadId"} element={<Tables />} />
				<Route path={"/thread/:threadId/*"} element={<Tables />} />
			</Routes>
		</div>
	);
};

export default One;
